console.log('[cw] add-pdt asset running', document.currentScript && document.currentScript.src);

if (!window.__cwGridBound) {
  window.__cwGridBound = true;

  function formatMoney(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n / 100);
  }

  function getSelectedPriceFromOption(select) {
    const opt = select.options[select.selectedIndex];
    if (!opt) return null;

    let raw = (opt.dataset && (opt.dataset.price || opt.dataset.variantPrice)) || '';
    if (!raw) {
      const m = (opt.textContent || '').match(/([\d\s.,]+)\s*(?:€|EUR)/i);
      if (m) {
        const euros = m[1].replace(/\s/g, '').replace(',', '.');
        const cents = Math.round(parseFloat(euros) * 100);
        return Number.isFinite(cents) ? cents : null;
      }
      return null;
    }
    const p = parseInt(raw, 10);
    return Number.isFinite(p) ? p : null;
  }

  function updateBtnPriceForSelect(select) {
    const pid = select.getAttribute('data-product-id') || (select.dataset && select.dataset.productId);
    if (!pid) return false;

    const span = document.querySelector(`.btn-add-to-cart .btn-price[data-product-id="${pid}"]`);
    if (!span) return false;

    const price = getSelectedPriceFromOption(select);
    if (price == null) return false;

    span.textContent = formatMoney(price);
    return true;
  }

  function updateCardPriceFromSelect(select) {
    let ok = updateBtnPriceForSelect(select);
    setTimeout(() => updateBtnPriceForSelect(select) || ok, 50);
    setTimeout(() => updateBtnPriceForSelect(select) || ok, 300);
    return ok;
  }

  function onVariantEvent(e) {
    const select = e.target.closest && e.target.closest('.variant-dropdown[name="id"], .variant-dropdown');
    if (!select) return;
    updateCardPriceFromSelect(select);
  }

  // Écoute en capture pour passer avant certains scripts d’apps
  document.addEventListener('change', onVariantEvent, true);
  document.addEventListener('input',  onVariantEvent, true);

  function initAll() {
    document.querySelectorAll('.variant-dropdown').forEach(updateCardPriceFromSelect);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Events potentiels du thème
  document.addEventListener('variant:changed', (e) => {
    const select = e.target && e.target.closest && e.target.closest('.variant-dropdown') || document.querySelector('.variant-dropdown');
    if (select) updateCardPriceFromSelect(select);
  }, true);

  document.addEventListener('product:change', (e) => {
    const select = e.target && e.target.closest && e.target.closest('.variant-dropdown') || document.querySelector('.variant-dropdown');
    if (select) updateCardPriceFromSelect(select);
  }, true);
}


(function () {
  if (window.__cbdsolCartSubmitBound) return;
  window.__cbdsolCartSubmitBound = true;

  function cartUrl() {
    return window.theme && window.theme.cartUrl || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart';
  }

  function refreshCart() {
    return new Promise(function (resolve, reject) {
      var $ = window.jQuery;
      var timer = setTimeout(function () {
        $(document).off('ajaxCart.afterUpdateHeaderCartHtml.cbdsolAdd', updated);
        reject(new Error('Cart refresh timeout'));
      }, 10000);
      function updated() {
        clearTimeout(timer);
        resolve();
      }
      $(document).one('ajaxCart.afterUpdateHeaderCartHtml.cbdsolAdd', updated);
      try {
        window.BT.updateHeaderCartHtml(true);
      } catch (error) {
        clearTimeout(timer);
        $(document).off('ajaxCart.afterUpdateHeaderCartHtml.cbdsolAdd', updated);
        reject(error);
      }
    });
  }


  // BOGOS updates gifts outside product forms; refresh the theme after it finishes.
  var giftRefreshTimer;
  var giftRefreshRunning = false;
  var giftRefreshPending = false;
  function scheduleGiftRefresh() {
    giftRefreshPending = true;
    clearTimeout(giftRefreshTimer);
    giftRefreshTimer = setTimeout(refreshGifts, 100);
  }
  async function refreshGifts() {
    if (giftRefreshRunning || !giftRefreshPending) return;
    if (!window.jQuery || !window.BT || typeof window.BT.updateHeaderCartHtml !== 'function') return;
    giftRefreshPending = false;
    giftRefreshRunning = true;
    try {
      await refreshCart();
    } catch (error) {
      console.warn('[CBDSOL] Gift cart display could not refresh', error);
    } finally {
      giftRefreshRunning = false;
      if (giftRefreshPending) scheduleGiftRefresh();
    }
  }
  ['fg-gifts:added', 'fg-cart:auto-updated', 'fg-gifts:updated'].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleGiftRefresh);
  });

  document.addEventListener('submit', async function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = new URL(form.action, location.href);
    if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return;
    if (!window.fetch || !window.FormData || !window.jQuery || !window.BT || typeof window.BT.updateHeaderCartHtml !== 'function') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.cbdsolAdding === 'true') return;
    form.dataset.cbdsolAdding = 'true';
    var body = new FormData(form);
    var button = event.submitter || form.querySelector('[type="submit"]');
    var originalDisabled = button && button.disabled;
    var errorBox = form.querySelector('[data-cbdsol-cart-error]');
    if (errorBox) errorBox.remove();
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }
    var added = false;
    try {
      var endpoint = action.pathname.replace(/(?:\.js)?\/?$/, '.js');
      var response = await fetch(endpoint, {method: 'POST', headers: {'Accept': 'application/json'}, credentials: 'same-origin', body: body});
      var result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Impossible d’ajouter ce produit. Veuillez réessayer.');
      added = true;
      await refreshCart();
      if (document.getElementById('bt-sidebar-cart') && typeof window.BT.showSidebar === 'function') {
        window.BT.showSidebar('#bt-sidebar-cart');
      } else {
        location.assign(cartUrl());
      }
    } catch (error) {
      if (added) {
        location.assign(cartUrl());
      } else {
        errorBox = document.createElement('p');
        errorBox.setAttribute('data-cbdsol-cart-error', '');
        errorBox.setAttribute('role', 'alert');
        errorBox.className = 'alert alert-danger';
        errorBox.textContent = error.message || 'Impossible d’ajouter ce produit. Veuillez réessayer.';
        form.appendChild(errorBox);
      }
    } finally {
      delete form.dataset.cbdsolAdding;
      if (button) {
        button.disabled = originalDisabled;
        button.removeAttribute('aria-busy');
      }
    }
  }, true);
})();
